import { render, staticRenderFns } from "./IconCircleClock.vue?vue&type=template&id=efe41e4c"
import script from "./IconCircleClock.vue?vue&type=script&lang=js"
export * from "./IconCircleClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports